import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ddd2d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "register-form"
}
const _hoisted_2 = { class: "label name" }
const _hoisted_3 = { class: "field-error" }
const _hoisted_4 = { class: "label is-mobile-terminal" }
const _hoisted_5 = { class: "label receipt_printer" }
const _hoisted_6 = { class: "field-error" }
const _hoisted_7 = {
  key: 0,
  class: "label terminal"
}
const _hoisted_8 = { class: "field-error" }
const _hoisted_9 = { class: "send-button" }
const _hoisted_10 = { class: "delete-modal" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Er du sikker på at du vil slette kassen?", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dette vil permanent slette kassen!", -1))
const _hoisted_13 = { class: "delete-modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createVNode(_component_TextButton, {
        class: _normalizeClass(["open-button", _ctx.openButtonClasses]),
        color: "black",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.register.name), 1),
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.arrowDownIcon
          }, null, 8, ["path"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(_component_CollapseTransition, null, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, [
                _createTextVNode(" Navn på Kasse "),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.name]
                ]),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.form.errors.name), 1)
              ]),
              _createElementVNode("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.terminal_is_mobile) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.terminal_is_mobile]
                ]),
                _createTextVNode(" Bruker mobil bankterminal ")
              ]),
              _createElementVNode("label", _hoisted_5, [
                _createTextVNode(" Navn på kvitteringsskriver "),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.receipt_printer) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.receipt_printer]
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.form.errors.receipt_printer), 1)
              ]),
              (!_ctx.form.terminal_is_mobile)
                ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                    _createTextVNode(" Betalingsterminal ID "),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.terminal_id) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.terminal_id]
                    ]),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.form.errors.terminal_id), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  color: "green",
                  onClick: _ctx.sendForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lagre")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _ctx.abortEdit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  color: "red",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteModal = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Slett")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDeleteModal = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "red",
                  onClick: _ctx.deleteRegister
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Slett")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}